export enum EnumLocation {
    covenant = "Convênio",
    administrative = "Administrativo",
    APP_COVENANT = "Convênio App"

}
